import generalTypes from './types';

export const initialStates = {
	loading: true,
	apiStatus: {
		loading: {},
	},
};

const generalReducers = (state = initialStates, action) => {
	switch (action.type) {
		case generalTypes.INITIALIZE.START:
			return {
				...state,
				loading: true,
			};
		case generalTypes.INITIALIZE.FINISH:
			return {
				...state,
				loading: false,
			};
		case generalTypes.API_STATUS.LOADING.START:
			return {
				...state,
				apiStatus: {
					loading: {
						...state.apiStatus.loading,
						...{ [action.payload]: 'true' },
					},
				},
			};

		case generalTypes.API_STATUS.LOADING.STOP: {
			const queue = { ...state.apiStatus.loading };
			delete queue[action.payload];
			return {
				...state,
				apiStatus: {
					loading: { ...queue },
				},
			};
		}

		default:
			return state;
	}
};

export default generalReducers;
